<script setup lang="ts">
withDefaults(
  defineProps<{ variant?: 'primary' | 'secondary' | 'ghost'; disabled?: boolean }>(),
  { variant: 'primary', disabled: false },
);
</script>

<template>
  <button :class="['btn', `btn--${variant}`]" :disabled="disabled" v-bind="$attrs">
    <slot />
  </button>
</template>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-2);
  border-radius: var(--r-lg);
  padding: 14px 20px;
  font-size: var(--fs-base);
  font-weight: 600;
  transition: transform 0.08s, background 0.15s;
}
.btn:active { transform: scale(0.98); }
.btn:disabled { opacity: 0.5; cursor: not-allowed; }
.btn--primary { background: var(--accent); color: var(--text-on-accent); }
.btn--primary:hover { background: var(--accent-hover); }
.btn--secondary { background: var(--bg-elevated); color: var(--text-primary); }
.btn--ghost { background: transparent; color: var(--text-primary); }
</style>
